import { IColumn } from '@kaleyra/emmy/dist/molecules/styledTable';
import React from 'react';
import i18n from '../../../../../../i18n/i18n';
import Outgoing from '../../../../../../assets/outgoingCallColor.svg';
import Incoming from '../../../../../../assets/incomingCallColor.svg';
import Styles from '../index.module.scss';
import cn from 'classnames';
import { Table, Tooltip } from '@kaleyra/emmy';
import { date12HrFormat } from '../../../../../../utils';
import { capitalize } from 'lodash';

export const expandColumnVoiceBody = (elementData: any): React.ReactNode => {
    const { original } = elementData;
    return (
		<>
			<Table
				columns={[
					{
						header: i18n.t('callID'),
						accessor: 'call_id',
						Cell: ({ original }) => (
							<div
								className={cn(
									Styles.callIdWrapper,
									Styles.rowWrapper
								)}
							>
								<Tooltip
									trigger={['hover']}
									title={original.call_id}
								>
									{original.call_id || '-'}
								</Tooltip>
							</div>
						),
					},
					{
						header: i18n.t('voceFlowExecutionId'),
						accessor: 'flow_execution_id',
						Cell: ({ original }) => (
							<div
								className={cn(
									Styles.callIdWrapper,
									Styles.rowWrapper
								)}
							>
								<Tooltip
									trigger={['hover']}
									title={original?.flow_execution_id}
								>
									{original.flow_execution_id || '-'}
								</Tooltip>
							</div>
						),
					},
				]}
				data={[original]}
			/>
		</>
	);
};

export const VoiceLogs = (): Array<IColumn> => [
			{
				header: i18n.t('mainType'),
				accessor: 'call_type',
				Cell: (tableData: any) => (
					<Tooltip
						placement="top"
						title={capitalize(tableData.original?.call_direction)}
						trigger={['hover']}
					>
						<div>
							<img
								src={
									tableData.original?.call_direction ===
									'incoming'
										? Outgoing
										: Incoming
								}
							/>
						</div>
					</Tooltip>
				),
			},
			{
				header: i18n.t('callFrom'),
				accessor: 'call_from',
				Cell: (tableData: any) => (
					<div className={cn(Styles.rowWrapper, Styles.fromNumber)}>
						{'+' + tableData.original.call_from?.replace('+', '') ||
							'-'}
					</div>
				),
			},
			{
				header: i18n.t('callTo'),
				accessor: 'call_to',
				Cell: (tableData: any) => (
					<div className={cn(Styles.rowWrapper, Styles.fromNumber)}>
						{'+' + tableData.original.call_to?.replace('+', '') ||
							'-'}
					</div>
				),
			},
			{
				header: i18n.t('voiceCallStartTime'),
				accessor: 'call_start_time',
				sortable: true,
				Cell: (tableData: any) => (
					<div>
						{tableData.original?.call_start_time
							? date12HrFormat(
									tableData.original.call_start_time,
									true
							  )
							: '-'}
					</div>
				),
			},
			{
				header: i18n.t('callStatus'),
				accessor: 'call_status',
				Cell: (tableData: any) => (
					<div className={cn(Styles.rowWrapper, Styles.fromNumber)}>
						{tableData.original.call_status || '-'}
					</div>
				),
			},
			{
				header: i18n.t('mainDuration'),
				accessor: 'call_duration',
                Cell: (tableData: any) => (
                    <div>
                        {tableData.original.call_duration ? `${tableData.original.call_duration} secs`: '-'}
                    </div>
                ),
			},
		];

    export const updateFiltersForVoice = (filters: any,  selFilters: any, whatsappVoiceData: any, remove?: boolean) => {
        let appliedOb = {};
            const { call_type, from_number, to_number, call_status, start_date  } = filters;
    
            if (call_type) {
                appliedOb = {
                    ...appliedOb,
                    call_type: remove
                        ? selFilters.call_type
                        : whatsappVoiceData?.data?.type[call_type] || '',
                };
            }
            if (from_number) {
                appliedOb = {
                    ...appliedOb,
                    from_number: remove ? selFilters.from_number : `From: ${from_number}`
                }
            }
            if (to_number) {
                appliedOb = {
                    ...appliedOb,
                    to_number: remove ? selFilters.to_number : `To: ${to_number}`
                }
            }
            if (call_status) {
                appliedOb = {
                    ...appliedOb,
                    call_status: remove
                        ? selFilters.call_status
                        : whatsappVoiceData?.data?.status[call_status] || '',
                };
            }
            // if (start_date) {
            //     appliedOb = {
            //         ...appliedOb,
            //         start_date: remove ? selFilters.start_date : `${i18n.t('startDate')} on: ${moment(start_date).format('DD MMM YYYY')}`
            //     }
            // }
            if (start_date) {
                let createdArr = start_date.split(',');
                const [start, end] = createdArr;
                appliedOb = {
                    ...appliedOb,
                    start_date: remove
                        ? selFilters.start_date
                        : `${i18n.t('KLR00112')} ${start} ${i18n.t(
                                'KLR00113'
                          )} ${end}`,
                };
            }
    
            return appliedOb;
    }